(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ishi_Singleproduct"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-product-recommendations"] && !Shopify.designMode) return;
  try {
    
// Robust Product Recommendations -> Swiper conversion (seeded shuffle)
(() => {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function hashStringToInt(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i);
      hash = hash & 0xFFFFFFFF;
    }
    return hash >>> 0;
  }

  function mulberry32(seed) {
    return function() {
      let t = seed += 0x6D2B79F5;
      t = Math.imul(t ^ t >>> 15, t | 1);
      t ^= t + Math.imul(t ^ t >>> 7, t | 61);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
  }

  function shuffleWithRng(array, rng) {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  onReady(() => {
    const initAllRecommendations = () => {
      const containers = Array.from(document.querySelectorAll('product-recommendations'));
      if (!containers.length) return;

      containers.forEach(container => {
        if (container.dataset.recommendationsInited === 'true') return;

        const waitForList = (cb) => {
          const ul = container.querySelector('ul.product-list');
          if (ul) return cb(ul);

          const mo = new MutationObserver((mutations, obs) => {
            const found = container.querySelector('ul.product-list');
            if (found) {
              obs.disconnect();
              cb(found);
            }
          });
          mo.observe(container, { childList: true, subtree: true });
          setTimeout(() => {
            const found = container.querySelector('ul.product-list');
            if (found) {
              try { mo.disconnect(); } catch(e){}
              cb(found);
            }
          }, 2000);
        };

        waitForList((ul) => {
          if (!ul) return;

          const items = Array.from(ul.querySelectorAll('li.grid__item'));
          const count = items.length;
          if (count === 0) return;

          const mainHandle = container.dataset.mainProductHandle || '';
          const mainId = container.dataset.mainProductId || '';
          const seedSource = mainHandle ? `${mainHandle}` : `${mainId}`;
          const seedInt = hashStringToInt(seedSource || 'default-seed');
          const rng = mulberry32(seedInt);

          let shuffled;
          try {
            shuffled = shuffleWithRng(items, rng);
            const fragment = document.createDocumentFragment();
            shuffled.forEach(li => fragment.appendChild(li));
            ul.innerHTML = '';
            ul.appendChild(fragment);
          } catch (err) {
            console.warn('Deterministic recommendations shuffle error:', err);
          }

          const itemsAfterShuffle = Array.from(ul.querySelectorAll('li.grid__item'));
          const shouldConvert = itemsAfterShuffle.length > 4;
          if (!shouldConvert) {
            const navHide = container.querySelector('.recommendations-controls') || container.querySelector('.slider-buttons');
            if (navHide) navHide.style.display = 'none';
            container.dataset.recommendationsInited = 'true';
            return;
          }

          const swiperEl = document.createElement('div');
          swiperEl.className = `swiper recommendations-swiper-${Math.random().toString(36).substr(2,6)}`;

          const wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';

          itemsAfterShuffle.forEach(li => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = li.innerHTML;
            wrapper.appendChild(slide);
          });

          swiperEl.appendChild(wrapper);
          ul.parentNode.replaceChild(swiperEl, ul);

          const prevBtn = container.querySelector('.slider-button--prev') || container.querySelector('.prev-btn') || container.querySelector('.slider-btn.prev-btn');
          const nextBtn = container.querySelector('.slider-button--next') || container.querySelector('.next-btn') || container.querySelector('.slider-btn.next-btn');
          const counterCurrent = container.querySelector('.slider-counter--current');
          const counterTotal = container.querySelector('.slider-counter--total');

          const nav = container.querySelector('.recommendations-controls') || container.querySelector('.slider-buttons');
          if (nav) nav.style.display = '';

          let swiper = null;
          try {
            swiper = new Swiper(swiperEl, {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                nextEl: nextBtn || undefined,
                prevEl: prevBtn || undefined,
              },
              breakpoints: {
                480: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              },
            });
          } catch (err) {
            console.error('Swiper init error:', err);
          }

          if (!swiper) {
            if (nextBtn) nextBtn.addEventListener('click', () => {});
            if (prevBtn) prevBtn.addEventListener('click', () => {});
            container.dataset.recommendationsInited = 'true';
            return;
          }

          const updateState = () => {
            if (counterTotal) counterTotal.textContent = swiper.slides ? swiper.slides.length : 0;
            if (counterCurrent) counterCurrent.textContent = (swiper.realIndex || 0) + 1;

            if (prevBtn) {
              if (swiper.isBeginning) {
                prevBtn.classList.add('swiper-button-disabled');
                prevBtn.setAttribute('aria-disabled', 'true');
                prevBtn.setAttribute('disabled', '');
                prevBtn.setAttribute('tabindex', '-1');
              } else {
                prevBtn.classList.remove('swiper-button-disabled');
                prevBtn.setAttribute('aria-disabled', 'false');
                prevBtn.removeAttribute('disabled');
                prevBtn.removeAttribute('tabindex');
              }
            }

            if (nextBtn) {
              if (swiper.isEnd) {
                nextBtn.classList.add('swiper-button-disabled');
                nextBtn.setAttribute('aria-disabled', 'true');
                nextBtn.setAttribute('disabled', '');
                nextBtn.setAttribute('tabindex', '-1');
              } else {
                nextBtn.classList.remove('swiper-button-disabled');
                nextBtn.setAttribute('aria-disabled', 'false');
                nextBtn.removeAttribute('disabled');
                nextBtn.removeAttribute('tabindex');
              }
            }
          };

          setTimeout(updateState, 80);
          swiper.on('slideChange', updateState);

          const navParams = (swiper && swiper.params && swiper.params.navigation) || {};
          const navWasWired = navParams && (navParams.nextEl || navParams.prevEl);
          if (!navWasWired) {
            if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext());
            if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev());
          }

          container.dataset.recommendationsInited = 'true';
        });
      });
    };

    initAllRecommendations();
    setTimeout(initAllRecommendations, 500);
    setTimeout(initAllRecommendations, 1500);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-backup"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-productc-bkup-25-11-2025"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-bkup-25-11-2025"]) return;
  try {
    
// Robust Product Recommendations -> Swiper conversion (seeded shuffle)
(() => {
  // Wait until DOM ready
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      } else {
      fn();
    }
  }

  // Simple string -> 32-bit integer hash (djb2 variant)
  function hashStringToInt(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i); /* hash * 33 + c */
      // keep in 32-bit int range
      hash = hash & 0xFFFFFFFF;
    }
    return hash >>> 0; // convert to unsigned
  }

  // Mulberry32 PRNG seeded with 32-bit integer
  function mulberry32(seed) {
    return function() {
      let t = seed += 0x6D2B79F5;
      t = Math.imul(t ^ t >>> 15, t | 1);
      t ^= t + Math.imul(t ^ t >>> 7, t | 61);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
      }
    }

  // Fisher-Yates shuffle using provided RNG function (returns new array)
  function shuffleWithRng(array, rng) {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  onReady(() => {
    const initAllRecommendations = () => {
      const containers = Array.from(document.querySelectorAll('product-recommendations'));
      if (!containers.length) return;

      containers.forEach(container => {
        // If already initialized, skip
        if (container.dataset.recommendationsInited === 'true') return;

        // Wait for the list to be present (fallback: MutationObserver)
        const waitForList = (cb) => {
        const ul = container.querySelector('ul.product-list');
          if (ul) return cb(ul);

          const mo = new MutationObserver((mutations, obs) => {
            const found = container.querySelector('ul.product-list');
            if (found) {
              obs.disconnect();
              cb(found);
            }
          });
          mo.observe(container, { childList: true, subtree: true });
          setTimeout(() => {
            const found = container.querySelector('ul.product-list');
            if (found) {
              try { mo.disconnect(); } catch(e){}
              cb(found);
            }
          }, 2000);
        };

        waitForList((ul) => {
          if (!ul) return;

          // gather items (NodeList -> Array of LI elements)
        const items = Array.from(ul.querySelectorAll('li.grid__item'));
        const count = items.length;
          if (count === 0) return;

          // derive seed from container attribute (main product handle preferred)
          const mainHandle = container.dataset.mainProductHandle || '';
          const mainId = container.dataset.mainProductId || '';
          const seedSource = mainHandle ? `${mainHandle}` : `${mainId}`;
          const seedInt = hashStringToInt(seedSource || 'default-seed');
          const rng = mulberry32(seedInt);

          // Shuffle deterministically using seeded RNG
          let shuffled;
          try {
            shuffled = shuffleWithRng(items, rng);
            // Move nodes in DOM to shuffled order
            const fragment = document.createDocumentFragment();
            shuffled.forEach(li => fragment.appendChild(li));
            ul.innerHTML = ''; // clear (moves nodes) then append
            ul.appendChild(fragment);
          } catch (err) {
            console.warn('Deterministic recommendations shuffle error:', err);
            // fallback: leave original order
          }

          // re-collect items after shuffle (fresh order)
          const itemsAfterShuffle = Array.from(ul.querySelectorAll('li.grid__item'));
          const shouldConvert = itemsAfterShuffle.length > 4; // same conversion rule as before
          if (!shouldConvert) {
            // hide nav if small set
            const navHide = container.querySelector('.recommendations-controls') || container.querySelector('.slider-buttons');
            if (navHide) navHide.style.display = 'none';
            container.dataset.recommendationsInited = 'true';
            return;
          }

          // build swiper wrapper from the shuffled list
        const swiperEl = document.createElement('div');
          swiperEl.className = `swiper recommendations-swiper-${Math.random().toString(36).substr(2,6)}`;

        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

          itemsAfterShuffle.forEach(li => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          // preserve the grid__item markup inside slide (use innerHTML)
          slide.innerHTML = li.innerHTML;
          wrapper.appendChild(slide);
        });

        swiperEl.appendChild(wrapper);

          // Replace UL with swiper
        ul.parentNode.replaceChild(swiperEl, ul);

          // find controls (support both variants)
          const prevBtn = container.querySelector('.slider-button--prev') || container.querySelector('.prev-btn') || container.querySelector('.slider-btn.prev-btn');
          const nextBtn = container.querySelector('.slider-button--next') || container.querySelector('.next-btn') || container.querySelector('.slider-btn.next-btn');
          const counterCurrent = container.querySelector('.slider-counter--current');
          const counterTotal = container.querySelector('.slider-counter--total');

          // show nav area if present
          const nav = container.querySelector('.recommendations-controls') || container.querySelector('.slider-buttons');
          if (nav) nav.style.display = '';

          // Initialize Swiper
          let swiper = null;
          try {
            swiper = new Swiper(swiperEl, {
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
                nextEl: nextBtn || undefined,
                prevEl: prevBtn || undefined,
            },
            breakpoints: {
                480: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            },
          });
          } catch (err) {
            console.error('Swiper init error:', err);
          }

          if (!swiper) {
            if (nextBtn) nextBtn.addEventListener('click', () => { /* no-op */ });
            if (prevBtn) prevBtn.addEventListener('click', () => { /* no-op */ });
            container.dataset.recommendationsInited = 'true';
            return;
          }

          // update counters & nav disabled state
          const updateState = () => {
            if (counterTotal) counterTotal.textContent = swiper.slides ? swiper.slides.length : 0;
            if (counterCurrent) counterCurrent.textContent = (swiper.realIndex || 0) + 1;

            if (prevBtn) {
              if (swiper.isBeginning) {
                prevBtn.classList.add('swiper-button-disabled');
                prevBtn.setAttribute('aria-disabled', 'true');
                prevBtn.setAttribute('disabled', '');
                prevBtn.setAttribute('tabindex', '-1');
              } else {
                prevBtn.classList.remove('swiper-button-disabled');
                prevBtn.setAttribute('aria-disabled', 'false');
                prevBtn.removeAttribute('disabled');
                prevBtn.removeAttribute('tabindex');
              }
            }

            if (nextBtn) {
              if (swiper.isEnd) {
                nextBtn.classList.add('swiper-button-disabled');
                nextBtn.setAttribute('aria-disabled', 'true');
                nextBtn.setAttribute('disabled', '');
                nextBtn.setAttribute('tabindex', '-1');
    } else {
                nextBtn.classList.remove('swiper-button-disabled');
                nextBtn.setAttribute('aria-disabled', 'false');
                nextBtn.removeAttribute('disabled');
                nextBtn.removeAttribute('tabindex');
    }
    }
          };

          // initial state
          setTimeout(updateState, 80);

          // update on slide change
          swiper.on('slideChange', updateState);

          // fallback if Swiper didn't wire buttons
          const navParams = (swiper && swiper.params && swiper.params.navigation) || {};
          const navWasWired = navParams && (navParams.nextEl || navParams.prevEl);
          if (!navWasWired) {
            if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext());
            if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev());
          }

          // mark as initialized
          container.dataset.recommendationsInited = 'true';
        }); // waitForList
      }); // containers.forEach
    }; // initAllRecommendations

    // initial attempt + small retry to make sure late-rendered sections initialize
    initAllRecommendations();
    setTimeout(initAllRecommendations, 500);
    setTimeout(initAllRecommendations, 1500);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
